import { render, staticRenderFns } from "./EmployeeTags.vue?vue&type=template&id=6d9acdbb&"
import script from "./EmployeeTags.vue?vue&type=script&lang=js&"
export * from "./EmployeeTags.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports